/* eslint-disable */

$(document).ready(function () {

  $(".filter-title").click(function () {
    $(this).toggleClass("active")
    $(this).next(".filter-block").slideToggle("middle");
  });

});
